import { Col, Row } from 'antd'
import { isEmpty } from 'lodash'
import React from 'react'
import { translate } from 'react-i18next'

const AnnouncementMsg = ({ t, announcement }) => {
    return (
        !isEmpty(announcement) && announcement.length > 0 ? (
            <Row className="announcement-row">
                <Col span={24}>
                    <div className="participant-announcement" >
                        <div className="participant-announcement-body">
                            <div className="announcement-head">
                                <p className="announcement-title">{t('lobby_participant.announcement_text')}</p>
                            </div>
                            <div className="announcement-body">
                                {announcement}
                            </div>
                        </div>
                    </div >
                </Col>
            </Row>
        ) : null
    )
}

export default translate()(AnnouncementMsg)
